import './sentry'
import { Amplify } from 'aws-amplify'
import { createRoot } from 'react-dom/client'
import { StytchB2BProvider } from '@stytch/react/b2b'
import { createStytchB2BHeadlessClient } from '@stytch/react/b2b/headless'
import Main from './Main'
import './index.css'

// import reportWebVitals from './reportWebVitals'

Amplify.configure({
  Auth: {
    Cognito: {
      region: 'us-west-2',
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_USER_POOL_WEB_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_ZAPI_AUTH_DOMAIN,
          redirectSignIn: [`${window.location.origin}/`],
          redirectSignOut: [`${window.location.origin}/`],
          responseType: 'code',
          scopes: [],
        },
      },
    },
  },
})

const stytch = createStytchB2BHeadlessClient(
  import.meta.env.VITE_STYTCH_PUBLIC_TOKEN,
  {
    // Use the custom domain set up in Stytch dashboard
    endpointOptions: {
      apiDomain: 'login.pixydocs.com',
      testApiDomain: 'login.pixydocs.dev',
    },
  },
)

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  // <React.StrictMode>
  <StytchB2BProvider stytch={stytch}>
    <Main />
  </StytchB2BProvider>,
  // </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
